// Search result structure
export interface SearchResult {
  title: string;
  path: string;
  type: 'page' | 'section' | 'content';
  description?: string;
}

const isNonProd = import.meta.env.VITE_ENV !== 'prod';

// Searchable content database - centralized for entire app
export const searchableContent: SearchResult[] = [
  { title: 'Dashboard', path: '/dashboard', type: 'page', description: 'View your course progress and overview' },
  { title: 'My Team', path: '/my-team', type: 'page', description: 'Manage your team members and their progress' },
  { title: 'My Progress', path: '/my-progress', type: 'page', description: 'Track your learning progress and achievements' },
  { title: 'Certifications', path: '/certification-courses', type: 'page', description: 'Browse certification programs' },
  { title: 'Course Catalog', path: '/all-courses', type: 'page' as const, description: 'Explore all available courses' },
  ...(isNonProd ? [
    { title: 'Resource Library', path: '/resource-library', type: 'page' as const, description: 'Access learning resources and materials' },
  ] : []),
  { title: 'Plans', path: '/plans', type: 'page' as const, description: 'View and manage subscription plans' },
  { title: 'Billing', path: '/billing', type: 'page' as const, description: 'Manage billing and payment information' },
];

// Search filter function
export function filterSearchResults(query: string): SearchResult[] {
  if (query.trim() === '') {
    return [];
  }

  const lowercaseQuery = query.toLowerCase();

  return searchableContent.filter((item) =>
    item.title.toLowerCase().includes(lowercaseQuery) ||
    item.description?.toLowerCase().includes(lowercaseQuery)
  );
}

